/**
 * HeartPlus role granting admin access within a clinic. Value of the active
 * clinic's `practitioner-role-type` (sourced per-clinic from FHIR and surfaced
 * as `activeClinicRole` on the user app configurations), not a global token claim.
 */
export const SYSTEM_ADMIN_ROLE = 'SYSTEM_ADMIN';

/** HeartPlus physician role for the active clinic (same source as {@link SYSTEM_ADMIN_ROLE}). */
export const PHYSICIAN_ROLE = 'PHYSICIAN';

/** 91Life-internal persona mirroring {@link SYSTEM_ADMIN_ROLE}'s permissions; same per-clinic source. */
export const SUPER_USER_ROLE = 'SUPER_USER';
